<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="button-group">
    @if (rightItem && matchedItems && matchedItems.length > 0) {
      <button mat-raised-button color="primary" (click)="onNationalityCorrected()">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
    }
    <button mat-raised-button color="primary" (click)="onCreateNationality()">
      <mat-icon>add</mat-icon>
      Add Nationality
    </button>
  </div>
  <app-lookup-table
      [items]="nationalities()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditNationality($event)"
      (deleteClick)="onDeleteNationality($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
